import { useWebSocketReconnect, type WsStatus } from "./use-websocket-reconnect";

const WS_URL = `${process.env.BUN_PUBLIC_WS_BASE_URL}/v1/ws/connect`;

export type { WsStatus };

export interface NeighborUser {
  user_id: string;
  username?: string;
  current_club_id?: string | null;
  current_club_name?: string | null;
  connected_server_id?: string;
  lat: number;
  lng: number;
  speed_kmph?: number;
  heading: number;
}

interface UseMapWsOptions {
  onNeighborUpdate?: (users: NeighborUser[]) => void;
  // Connecting streams every nearby user's live location — keep it opt-in
  // rather than firing on mount.
  enabled?: boolean;
}

export function useMapWs({ onNeighborUpdate, enabled = false }: UseMapWsOptions = {}) {
  const { status, send } = useWebSocketReconnect(WS_URL, {
    enabled,
    onMessage(evt) {
      try {
        const msg = JSON.parse(evt.data);
        if (msg.action === "neighbor_update" && Array.isArray(msg.payload)) {
          onNeighborUpdate?.(msg.payload);
        }
      } catch {}
    },
  });

  function sendViewportUpdate(lat: number, lng: number, radiusMeters: number) {
    send(
      JSON.stringify({
        action: "viewport_update",
        payload: { lat, lng, radius_meters: radiusMeters },
      }),
    );
  }

  return { status, sendViewportUpdate };
}
